mutation SendEventFollowUps(
  $eventId: ID!
  $segment: EventFollowUpSegmentEnum!
) {
  sendEventFollowUps(input: { eventId: $eventId, segment: $segment }) {
    queuedCount
  }
}
